import {observable, action, runInAction} from 'mobx';
import {IQueryParams} from '../../types/IQueryParams';
import Api from '../../services/api';
import {IPathFinder} from "../../types/IPathFinder";

class PathFinderStore {
    @observable public pathFinder?:IPathFinder;
    @observable public loading?: boolean;

    @action
    public getPathFinder = async (params: IQueryParams) => {
        try {
            this.pathFinder = undefined;
            this.loading = true;
            const pathFinder = await Api.fetchPathFinder(params);
            runInAction(() => {
                this.pathFinder = pathFinder;
            });
        } catch(e) {
            console.log(e);
        } finally {
            runInAction(() => {
                this.loading = false;
            })
        }
    };
}

const pathFinderStore = new PathFinderStore();

export default pathFinderStore;
